import { createTheme, responsiveFontSizes, adaptV4Theme } from '@mui/material';

import { Theme } from '@mui/material/styles';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface (remove this line if you don't have the rule enabled)
  interface DefaultTheme extends Theme {}
}

export const BaseTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: ['"Open Sans"', 'Helvetica', 'Arial', '"sans - serif"'].join(
      ',',
    ),
    h2: {
      fontSize: '28px',
      fontWeight: 600,
      letterSpacing: '-1px',
      marginBottom: '15px',
      lineHeight: 1.4,
    },
  },
  palette: {
    primary: {
      main: '#0066cc',
    },
    secondary: {
      main: '#d53a0a',
    },
    error: {
      main: '#f44336',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
  },
});

const BeaconTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: BaseTheme.palette,
  typography: {
    fontFamily: BaseTheme.typography.fontFamily,
    h1: {
      fontSize: '2.5rem',
      fontWeight: 300,
      letterSpacing: '-1px',
      color: '#4d4f51',
      marginBottom: '20px',
      verticalAlign: 'baseline',
      '-webkit-font-smoothing': 'antialiased',
      fontStyle: 'normal',
      fontVariantCaps: 'normal',
      fontVariantEastAsian: 'normal',
      fontVariantLigatures: 'normal',
      fontVariantNumeric: 'normal',
      '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
      fontFamily: 'Open Sans',
    },
    h2: {
      fontSize: '1.25rem',
      fontWeight: 600,
      letterSpacing: '-1px',
      marginBottom: '15px',
      lineHeight: 1.4,
    },
    h3: {
      fontSize: '1.0rem',
      fontWeight: 400,
      [BaseTheme.breakpoints.only('xs')]: {
        fontSize: '1.25rem',
        fontWeight: 400,
      },
    },
    body1: {
      fontSize: '1.0rem',
    },
    caption: {
      fontSize: '0.95rem',
      [BaseTheme.breakpoints.only('xs')]: {
        fontSize: '0.8rem',
      },
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
    },
    MuiSkeleton: {
      defaultProps: {
        animation: 'wave',
      },
    },
    MuiLinearProgress: {
      defaultProps: {
        variant: 'query',
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          subtitle1: 'p',
          subtitle2: 'p',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        MenuProps: { variant: 'menu' },
      },
    },
  },
});

export default responsiveFontSizes(BeaconTheme);
